import * as yup from 'yup';
import { TFunction } from 'i18next';
import { CreateCompanyFormFields } from '../consts';
import { ICreateCompanyForm } from '../interfaces';

export const createCompanySchema = (
    t: TFunction
): yup.ObjectSchema<ICreateCompanyForm> =>
    yup.object().shape({
        [CreateCompanyFormFields.NAME]: yup
            .string()
            .required(t('tools.validation.nameRequired')),
        [CreateCompanyFormFields.ACCEPT_TERMS]: yup
            .boolean()
            .oneOf([true], t('tools.validation.acceptTermsRequired'))
            .required(),
    });
